import App from './App.vue';

export default {
  path: '/CDS_VF_HeadquarterDetail',
  name: 'CDS_VF_HeadquarterDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '本部体制詳細',
      controller: 'CDS_CTR_HeadquarterDetail',
    },
  },
};
